/*
 * @Author: your name
 * @Date: 2021-05-14 16:06:38
 * @LastEditTime: 2022-01-21 17:33:50
 * @LastEditors: zhujuan
 * @Description: In User Settings Edit
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-plan/plan/_api/index.js
 */

import { apiService } from '@/frameworks/http/request'
import store from '@/frameworks/store/index'
let prefix = 'NQCS/DoAction?act='
let HospitalCode = store.state.user.HospitalCode
export function GetZKJHList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZKJHList`,
    method: 'post',
    data: params
  })
}

export function SavePJ(params) {
  return apiService({
    url: `${prefix}SavePJ`,
    method: 'post',
    data: params
  })
}

export function DelPJ(params) {
  return apiService({
    url: `${prefix}DelPJ`,
    method: 'post',
    data: params
  })
}
